export default "__VITE_ASSET__BEOw4Smg__"